<div class="modal-header">
    <h4 class="modal-title">Configuración global preproyectos</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-divider class="mt-2"></mat-divider>
<div class="modal-body">
    <mat-dialog-content>
        <div class="row">
            <label class="">Fechas default de todos los preproyectos; al entrar al paso 2 se prellenan y ahí se pueden editar por estrategia.</label>
        </div>
        <div class="row mt-3">
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fecha inicio - Fecha fin</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Fecha Inicio" [(ngModel)]="data.fecha_inicio">
                        <input matEndDate placeholder="Fecha Fin" [(ngModel)]="data.fecha_fin">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>
      </mat-dialog-content>
</div>
<mat-divider class="mt-3"></mat-divider>
<div class="modal-footer mt-3">
    <button mat-flat-button class="bg-success text-white" (click)="guardarPreproyectoGlobal(data)">Guardar <mat-icon>save</mat-icon></button>
</div>
